<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="checked-list">
                    <icon name="shopping-basket"></icon>
                    สั่งซื้อ
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "checked-list-layout"
    }
</script>

<style scoped>

</style>